import './common.scss';

export default {
  errorWrapper: "alert alert-danger error",
  errorMessage: "error-message",
  warningWrapper: "alert alert-warning",
  loadingMessage: "loading-message",
  requiredLabel: 'label-override',
  requiredLegend: 'legend-override',
  requiredIndicator: "required-indicator",
  errorIndicator: 'glyphicon glyphicon-exclamation-sign error-icon'
}



// WEBPACK FOOTER //
// src/common/common.style.js